import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, query, where, orderBy } from "firebase/firestore";
import { db } from "./config";

// Get all box types
export const getAllBoxTypes = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "boxTypes"));
    const boxTypes = [];
    querySnapshot.forEach((doc) => {
      boxTypes.push({ id: doc.id, ...doc.data() });
    });
    return boxTypes;
  } catch (error) {
    console.error("Error getting box types: ", error);
    return [];
  }
};

// Get only active box types
export const getActiveBoxTypes = async () => {
  try {
    // First try with ordering by created_at
    const q = query(
      collection(db, "boxTypes"), 
      where("state", "==", "active"),
      orderBy("created_at", "desc")
    );
    const querySnapshot = await getDocs(q);
    const boxTypes = [];
    querySnapshot.forEach((doc) => {
      boxTypes.push({ id: doc.id, ...doc.data() });
    });
    return boxTypes;
  } catch (error) {
    console.error("Error with ordered query, trying without orderBy:", error);
    // If ordering fails, try without orderBy
    try {
      const q = query(
        collection(db, "boxTypes"), 
        where("state", "==", "active")
      );
      const querySnapshot = await getDocs(q);
      const boxTypes = [];
      querySnapshot.forEach((doc) => {
        boxTypes.push({ id: doc.id, ...doc.data() });
      });
      return boxTypes;
    } catch (secondError) {
      console.error("Error getting active box types: ", secondError);
      return [];
    }
  }
};

// Add new box type
export const addBoxType = async (boxTypeData) => {
  try {
    const docRef = await addDoc(collection(db, "boxTypes"), boxTypeData);
    return docRef.id;
  } catch (error) {
    console.error("Error adding box type: ", error);
    throw error;
  }
};

// Update box type
export const updateBoxType = async (id, boxTypeData) => {
  try {
    const boxTypeRef = doc(db, "boxTypes", id);
    await updateDoc(boxTypeRef, boxTypeData);
  } catch (error) {
    console.error("Error updating box type: ", error);
    throw error;
  }
};

// Delete box type
export const deleteBoxType = async (id) => {
  try {
    const boxTypeRef = doc(db, "boxTypes", id);
    await deleteDoc(boxTypeRef);
  } catch (error) {
    console.error("Error deleting box type: ", error);
    throw error;
  }
}; 